import React from 'react';
import { styled } from 'linaria/react';
import { BoxButton } from '../../StartPage/ContentRendererComponents/ColorBox';

const TextWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: ${props => props.textPosition};
  width: 100%;
  max-width: 90rem;
  margin: 0 auto;

  .inner-wrapper {
    display: flex;
    flex-direction: column;
    align-items: ${props => props.textPosition};
    justify-content: ${props => props.textPosition};
    background: ${props => props.background};
    width: ${props => (props.isFullWidth ? '100%' : 'fit-content')};

    ul {
      list-style-type: disc;
      margin-left: 1rem;
    }
  }
  .text-content {
    color: ${props => props.color};
    max-width: 750px;
    padding: 1.5rem;
    h1 {
      margin: 0 0 0.3rem 0;
    }
    h2,
    h3 {
      margin: 0.5rem 0 0.3rem 0;
    }
    p {
      margin: 0;
      line-height: 1.4;
    }
    a {
      color: ${props => props.color} !important;
    }
  }
  .wideLink {
    padding-bottom: 1.5rem;
  }
`;

const positionClasses = {
  mitten: 'center',
  höger: 'flex-end',
  vänster: 'flex-start'
};

const Text = ({
  text,
  textHexColor,
  backgroundHexColor,
  position,
  fullWidth,
  buttonText,
  buttonTheme,
  link
}) => {
  const textColor = textHexColor?.value ?? 'svart';
  const backgroundColor = backgroundHexColor?.value ?? 'vit';
  const isFullWidth = Boolean(fullWidth?.value);
  const textContent = text?.value;
  const textPosition = positionClasses[position?.value] ?? 'center';
  const btnTheme = buttonTheme?.value;
  const btnText = buttonText?.value;
  const linkUrl = link?.value;

  return (
    <TextWrapper
      textPosition={textPosition}
      color={textColor}
      background={backgroundColor}
      isFullWidth={isFullWidth}
    >
      <div className="inner-wrapper">
        <div
          className="text-content"
          dangerouslySetInnerHTML={{ __html: textContent }}
        />
        {btnTheme && btnText && linkUrl && (
          <a href={linkUrl} className="wideLink" aria-label={btnText}>
            <BoxButton className={btnTheme}>{btnText}</BoxButton>
          </a>
        )}
      </div>
    </TextWrapper>
  );
};

export default Text;
